import { render, staticRenderFns } from "./ui-dialog.vue?vue&type=template&id=8a5a6806&scoped=true"
import script from "./ui-dialog.vue?vue&type=script&lang=js"
export * from "./ui-dialog.vue?vue&type=script&lang=js"
import style0 from "./ui-dialog.vue?vue&type=style&index=0&id=8a5a6806&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5a6806",
  null
  
)

export default component.exports